import styled from 'styled-components';
import { NavLink as NavLinkComponent } from 'react-router-dom';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const NavLink = styled(NavLinkComponent)`
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin: 0 4px;
  font-size: 16px;
  font-weight: 400;
  color: ${colors.grey300};
  transition: color 100ms ease-out;
  white-space: nowrap;
  text-decoration: none;
  height: 46px;
  line-height: 46px;
  border-bottom: 2px solid transparent;

  &.active {
    color: ${colors.white};
    font-weight: 500;
    border-bottom: 2px solid ${colors.grey200};
  }
`;
